import type { SubComponentsReturnType } from '../../types';

import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import type { RedditPostComponentsProps } from './types';

export function useRedditPostComponents(props: RedditPostComponentsProps): SubComponentsReturnType {
	return {
		header: <Header {...props} />,
		body: <Body {...props} />,
		footer: <Footer {...props} />,
	};
}
